import React from 'react';
import { cn } from '../../lib/utils';
interface FilterChipProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  label: string;
}
export function FilterChip({
  active,
  label,
  className,
  ...props
}: FilterChipProps) {
  return <button type="button" className={cn('inline-flex items-center rounded-full border px-3.5 py-1.5 text-sm font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2', active ? 'border-primary-600 bg-primary-50 text-primary-700 shadow-sm' : 'border-gray-200 bg-white text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-900', className)} {...props} data-id="element-309">
      {label}
    </button>;
}